import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";
import { useSettings } from "@/hooks/useData";

export function MobileBar() {
  const s = useSettings();
  const { pathname } = useLocation();
  if (pathname === "/kontakt") return null;
  return (
    <div
      data-testid="mobile-action-bar"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-2 border-t border-line bg-paper/90 backdrop-blur-xl"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a href={`tel:${s?.phone_link || ""}`} data-testid="mobile-action-call-button" className="flex items-center justify-center gap-2 h-14 label text-ink border-r border-line">
        <Phone size={13} strokeWidth={1.5} /> Anrufen
      </a>
      <Link to="/kontakt" data-testid="mobile-action-quote-button" className="flex items-center justify-center h-14 label bg-ink text-paper">
        Offerte
      </Link>
    </div>
  );
}
